<!-- Before Request an OTC Screen -->
<div class="option-otc" *ngIf="getActiveStep() == beforeStep1Active">
  <f-alert variant="error" *ngIf="rootScope.activeCustTab?.otcData?.deliveryMethodConfigMiss">{{noConfigForDeliveryMethods}}</f-alert>
    <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData?.deliveryMethodApiFail">
      There was problem loading the data.<a href="javascript:void('0')" (click)="otcService.getOTCConfig()"
      class="btn-alert">Try again.</a> </f-alert>
      <span  *ngIf="!rootScope.activeCustTab?.otcData?.deliveryMethodConfigMiss && !rootScope.activeCustTab.otcData?.deliveryMethodApiFail">
  <p>Click Request OTC button to request a one-time code </p>
  <div class="btn-controls">
    <f-button text="Request OTC" title="Request OTC" [ngClass]="{'disableBtn': (rootScope.activeCustTab?.otcData?.deliveryMethodConfigMiss || rootScope.activeCustTab?.otcData?.deliveryMethodApiFai) }" (click)="onclickReqOtc()" [disabled]="(rootScope.activeCustTab?.otcData?.deliveryMethodConfigMiss || rootScope.activeCustTab?.otcData?.deliveryMethodApiFai)" type="button" variant="progressive"></f-button>                  
  </div>
</span>
</div>


<!-- After Request an OTC Screen -->
<div class="otc-panel" *ngIf="getActiveStep() != beforeStep1Active">

  <!-- Stepper Header of OTC  -->
    <div class="otc-container" *ngIf="!rootScope.activeCustTab.otcData.enterOTCScreen">
      <div class="step-container flex justify-space-between">
          <span [class]="(getActiveStep() === onStep1Active || getActiveStep() === onStep2Active || getActiveStep() === onStep3Active) ? 'step-val active': 'step-val'">
            <span [class]="(getActiveStep() === onStep1Active || getActiveStep() === onStep2Active || getActiveStep() === onStep3Active) ? 'step-circle active': 'step-circle'">   
          <span class="step-no"> <span *ngIf="(getActiveStep() === onStep1Active)">1</span>
           <span *ngIf="( getActiveStep() === onStep2Active || getActiveStep() === onStep3Active)"> <i class="fa-solid fa-check"></i></span> 
          </span></span>Select delivery method</span>
          
        <span [class]="(getActiveStep() === onStep2Active || getActiveStep() === onStep3Active) ? 'step-val active': 'step-val'">
          <span [class]="(getActiveStep() === onStep2Active || getActiveStep() === onStep3Active) ? (rootScope.activeCustTab.otcData?.selectedDeliveryMethod?.details?.length == 0 ? 'step-circle failure' : 'step-circle active' ):'step-circle'">
            <span class="step-no">
             <span *ngIf=" (getActiveStep() == onStep1Active || rootScope.activeCustTab.otcData.selectedDeliveryMethod?.details?.length > 0) && getActiveStep() != onStep3Active">2</span>
             <span *ngIf=" getActiveStep() === onStep2Active && rootScope.activeCustTab.otcData.selectedDeliveryMethod?.details?.length == 0"><i class="fa-regular fa-xmark"></i></span>
             <span *ngIf="getActiveStep() === onStep3Active"> <i class="fa-solid fa-check"></i></span> 
           </span></span>Select delivery address </span>
  
         <span [class]="getActiveStep() == onStep3Active ? 'step-val active': 'step-val'">
          <span [class]="getActiveStep() == onStep3Active ? ( (rootScope.activeCustTab.otcData.notEligiblePhoneNumber) || (rootScope.activeCustTab.otcData.otcDenied) ? 'step-circle failure' : 'step-circle active'): 'step-circle'">
          <span class="step-no"><span *ngIf="!rootScope.activeCustTab.otcData.notEligiblePhoneNumber && !rootScope.activeCustTab.otcData.otcDenied && !rootScope.activeCustTab.otcData.sendOTCSuccess">3</span>  
          <span *ngIf="rootScope.activeCustTab.otcData.sendOTCSuccess"> <i class="fa-solid fa-check"></i></span> 
    
            <span *ngIf="(rootScope.activeCustTab.otcData.notEligiblePhoneNumber) || (rootScope.activeCustTab.otcData.otcDenied)"> <i class="fa-regular fa-xmark"></i></span> 
          </span></span> Confirm and send </span> 
      </div>
    </div> 
  </div>

 <!-- Step 1 Where User choose Delivery Method -->
 <div class="email-deliver-method" *ngIf="getActiveStep() == onStep1Active">
  <p class="pin-content">
    Choose a delivery method:
  </p>
  <mat-radio-group [(ngModel)]="rootScope.activeCustTab.otcData.selectedDeliveryMethod" color="primary" class="account-selection" disableRipple
    aria-label="Select an option">
    <mat-radio-button *ngFor="let opt of rootScope.activeCustTab.otcData?.otcConfigData?.deliveryMethods" [value]="opt">{{ opt?.type | titlecase }}
    </mat-radio-button>
    <mat-radio-button *ngIf="!isDeliveryMethodAvailable(text)" [value]="null" disabled>
      Text 
    </mat-radio-button>
    <mat-radio-button *ngIf="!isDeliveryMethodAvailable(email)" [value]="null" disabled>
      Email 
    </mat-radio-button>
  </mat-radio-group>
  <div class="btn-controls">                    
    <f-button text="Continue" title="Continue" (click)="continueOnStep1()" [ngClass]="{'disableBtn': isSelectedDeliveryMethodEmpty()}"[disabled]="isSelectedDeliveryMethodEmpty()" type="button" variant="progressive" class=""></f-button>
  </div>
</div>

 <!-- Step 2 Where User choose Delivery Method Text/Email -->
 <div class="deliver-address" *ngIf="getActiveStep() == onStep2Active">       

  <!-- for-TEXT-flow -->
  <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData?.selectedDeliveryMethod?.details.length == 0 && rootScope.activeCustTab.otcData?.selectedDeliveryMethod?.type == 'text'">
    There’s no phone number on file. Try another method. </f-alert>

    <span *ngIf="rootScope.activeCustTab.otcData?.selectedDeliveryMethod?.details.length > 0 && rootScope.activeCustTab.otcData?.selectedDeliveryMethod?.type == 'text'">
  <p class="pin-content">
    Select the number where the one-time code will be sent to.
  </p>  
  <p>
    <f-alert variant="info" class="pin-content">
      Do not read any of the numbers below to the customer. The customer must provide and verify the number below, then you may select.    
  </f-alert>
</p>
  <mat-radio-group [(ngModel)]="selectedOption" color="primary" class="account-selection" 
    disableRipple aria-label="Select an option">
    <mat-radio-button *ngFor="let opt of rootScope.activeCustTab.otcData?.selectedDeliveryMethod?.details" [value]="opt" (change)="onPhoneNumberSelect(opt)">
      {{getDisplayNumber(opt)}}
    </mat-radio-button>
  </mat-radio-group>
</span>

     <!-- for-EMAIL-flow -->
    <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData?.selectedDeliveryMethod?.details.length == 0 && rootScope.activeCustTab.otcData?.selectedDeliveryMethod?.type == 'email'">
     There’s no email address on file. Try another method. </f-alert>

<span *ngIf="rootScope.activeCustTab.otcData?.selectedDeliveryMethod?.details.length > 0 && rootScope.activeCustTab.otcData?.selectedDeliveryMethod?.type == 'email'">
  <p class="pin-content">
    Select the email where the one-time code will be sent to.
  </p>  
  <p>
    <f-alert variant="info" class="pin-content">
      Do not read any of the emails below to the customer. The customer must provide and verify the email below, then you may select.    
  </f-alert>
</p>
  <mat-radio-group [(ngModel)]="rootScope.activeCustTab.otcData.selectedEmail" color="primary" class="account-selection"
    disableRipple aria-label="Select an option">
    <mat-radio-button *ngFor="let opt of rootScope.activeCustTab.otcData?.selectedDeliveryMethod?.details" [value]="opt?.emailAdress">{{ opt?.emailAdress}} 
    </mat-radio-button>
  </mat-radio-group>
</span>


  <div class="btn-controls">
    <f-button text="Back" title="Back" type="button" (click)="backOnStep2()" variant="action" class=""></f-button>
    <span *ngIf="rootScope.activeCustTab.otcData?.selectedDeliveryMethod?.details.length > 0">
    <f-button text="Continue" title="Continue" (click)="continueOnStep2()" type="button" variant="progressive" [ngClass]="{'disableBtn': !rootScope.activeCustTab.otcData.selectedPhoneNumber && !rootScope.activeCustTab.otcData.selectedEmail}" [disabled]="!rootScope.activeCustTab.otcData.selectedPhoneNumber && !rootScope.activeCustTab.otcData.selectedEmail"></f-button>
    </span>
  </div>
</div>

   <!-- Step 3 Where User had already choose  -->
  <div class="confirm-send" *ngIf="getActiveStep() == onStep3Active && !rootScope.activeCustTab.otcData.sendOTCSuccess">
      <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData.notEligiblePhoneNumber" class="status-msg">{{notEligibleErrMsg}}</f-alert>
      <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData.otcDenied" class="status-msg">{{deniedErrMsg}}</f-alert>
      <f-alert variant="error" *ngIf="rootScope.activeCustTab.otcData.generateOTCApiFailure" class="status-msg">{{generateOtcApiFailErrMsg}}</f-alert>
    <p class="pin-content" *ngIf="!rootScope.activeCustTab.otcData.notEligiblePhoneNumber && !rootScope.activeCustTab.otcData.otcDenied">
      The one-time code will be sent to: <strong>{{rootScope.activeCustTab.otcData.selectedDeliveryMethod?.type !=  'email' ? rootScope.activeCustTab.otcData?.selectedCountryCode : ''}} {{rootScope.activeCustTab.otcData.selectedDeliveryMethod?.type === 'email' ? rootScope.activeCustTab.otcData?.selectedEmail : rootScope.activeCustTab.otcData?.selectedPhoneNumber}}</strong>.   
    </p>


    <div class="btn-controls">
      <f-button text="Back" title="Back" (click)="backOnStep3()" type="button" variant="action" class=""></f-button>
      <f-button text="Send OTC" title="Send OTC" type="button" 
      [ngClass]="{'disableBtn': (rootScope.activeCustTab.otcData.otcDenied) || (rootScope.activeCustTab.otcData.notEligiblePhoneNumber) || (rootScope.activeCustTab.otcData.generateOTCInProgress)}"  
      (click)="otcService.generateOTC()"variant="progressive"
       [disabled]="(rootScope.activeCustTab.otcData.otcDenied) || (rootScope.activeCustTab.otcData.notEligiblePhoneNumber) || (rootScope.activeCustTab.otcData.generateOTCInProgress)"></f-button>
    </div>

  </div>
  
  <div class="success-msg" *ngIf="rootScope.activeCustTab.otcData.sendOTCSuccess && !rootScope.activeCustTab.otcData.enterOTCScreen">
    <f-alert variant="success" class="status-msg">Success! The One-Time Code has been
      sent.</f-alert>
    <ul>
      <li >The One-Time Code has been sent to:<strong>{{rootScope.activeCustTab.otcData.selectedDeliveryMethod?.type !=  'email' ? rootScope.activeCustTab.otcData?.selectedCountryCode : ''}} {{rootScope.activeCustTab.otcData.selectedDeliveryMethod?.type === 'email' ? rootScope.activeCustTab.otcData?.selectedEmail : rootScope.activeCustTab.otcData?.selectedPhoneNumber}}</strong></li>
      <li>The One-Time Code is only valid for <strong>10 minutes </strong>. Once the code has been received by the customer, 
        click the Enter OTC button below to enter the code. </li>
      
    </ul>
    <div class="btn-controls">
      <f-button text="Back" title="Back" type="button" (click)="backOnSendOTCScreen()" variant="action" class=""></f-button>
      <f-button text="Enter OTC" title="Enter OTC" (click)="clickEnterOTCButton()" type="button" variant="progressive"></f-button>
    </div>
  </div>

<div class="enter-otc" *ngIf="rootScope.activeCustTab.otcData.enterOTCScreen">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <p>Enter the One-Time Code provided by the Customer</p>
        <div class="success-msg" *ngIf="rootScope.activeCustTab.otcData.validateOtcLocked">
          <f-alert variant="error" class="status-msg">{{accountLockedMsg}}</f-alert>
        </div> 
        <div class="success-msg" *ngIf="rootScope.activeCustTab.otcData.validateOtcFail">
          <f-alert variant="error" class="status-msg">{{invalidOTCMsg}}</f-alert>
        </div>
        <div class="success-msg" *ngIf="rootScope.activeCustTab.otcData.validateOtcApiFailure">
          <f-alert variant="error" class="status-msg">{{validateOtcApiFailureMsg}}</f-alert>
        </div>  
        <div class="success-msg" *ngIf="rootScope.activeCustTab.otcData.otcExpired">
          <f-alert variant="error" class="status-msg">{{otcExpiredMsg}}</f-alert>
        </div> 
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
          <mat-form-field appearance="fill" class="component-box">
            <mat-label>One-Time Code</mat-label>
            <input [(ngModel)]="rootScope.activeCustTab.otcData.typedOTC"
              [formControl]="otcService.oneTimeCode"
              matInput
              id="nid"
              placeholder="Enter {{otcService.otcLenght}}-digit code"
            />
            <mat-error *ngIf="otcService.oneTimeCode.hasError('required')">
              <i class="fa-solid fa-circle-xmark"></i> Code is required
            </mat-error>
            <mat-error *ngIf="otcService.oneTimeCode.hasError('pattern')">
              <i class="fa-solid fa-circle-xmark"></i> Invalid format, try again.
            </mat-error>
            <mat-error *ngIf="otcService.oneTimeCode.hasError('minlength') && !otcService.oneTimeCode.hasError('pattern')">
              <i class="fa-solid fa-circle-xmark"></i> Code must be {{otcService.otcLenght}} characters
            </mat-error>
            <mat-error *ngIf="otcService.oneTimeCode.hasError('maxlength') && !otcService.oneTimeCode.hasError('pattern')">
              <i class="fa-solid fa-circle-xmark"></i> Code must be {{otcService.otcLenght}} characters
            </mat-error>
          </mat-form-field>
          
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="btn-controls">                  
          <f-button text="Cancel" title="Cancel" type="button" (click)="cancelVerifyCode()" variant="action" class=""></f-button>
          <f-button text="Verify Code" title="Verify Code" [ngClass]="{'disableBtn': otcService.oneTimeCode?.invalid || rootScope.activeCustTab.otcData.validateOtcLocked || rootScope.activeCustTab.otcData.validateOTCApiProcessing}" [disabled]="otcService.oneTimeCode?.invalid || rootScope.activeCustTab.otcData.validateOtcLocked || rootScope.activeCustTab.otcData.validateOTCApiProcessing || rootScope.activeCustTab.otcData.generateOTCInProgress " 
          variant="progressive" (click)="verifyCode()" type="button" variant="progressive"></f-button>

        </div>
      </div>
    </div>
  </div>
</div>